// extracted by mini-css-extract-plugin
export default {"invite":"InvitePage_invite__gBdWE","invitePage":"InvitePage_invitePage__-w72Y","declineBtn":"InvitePage_declineBtn__PVrv6"};